import { render, staticRenderFns } from "./StatTitle.vue?vue&type=template&id=a284fa60&scoped=true&"
import script from "./StatTitle.vue?vue&type=script&lang=js&"
export * from "./StatTitle.vue?vue&type=script&lang=js&"
import style0 from "./StatTitle.vue?vue&type=style&index=0&id=a284fa60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a284fa60",
  null
  
)

export default component.exports